export const formatValue = (value, format = "decimal", includeSign = true, precision = 2) => {
	var sign;
	var _value = value;

	if (value === undefined || value === null) {
		_value = 0;
	}
    
    if (includeSign) {
        sign = _value < 0 ? "-" : "+";
    } else {
        sign = "";
    }
	return (
		sign +
		" " +
		Math.abs(_value).toLocaleString("nl-NL", {
			style: format,
			currency: "EUR",
			maximumFractionDigits: precision 
		})
	);
};

export const formatPercentage = (value, includeSign = true ) => {
	var sign;
    
    if (includeSign) {
        sign = value < 0 ? "-" : "+";
    } else {
        sign = "";
    }
	return (
		sign +
		"" +
		Math.abs(Math.round(value, 1))
		+ "%"
	);
};

/**
 * Determines the change title based on the selected time period
 * @param {Object} startDate - Start date (dayjs object)
 * @param {Object} endDate - End date (dayjs object)
 * @param {string} defaultTitle - Default title to return if dates are invalid (default: "vs previous month")
 * @returns {string} Change title string (e.g., "vs previous week", "vs previous month", "vs previous 30 days")
 */
export const getChangeTitle = (startDate, endDate, defaultTitle = "vs previous month") => {
	if (!startDate || !endDate) {
		return defaultTitle;
	}

	const daysDiff = endDate.diff(startDate, 'day') + 1; // +1 to include both start and end dates
	
	// Check if it's approximately a week (6-8 days)
	if (daysDiff >= 6 && daysDiff <= 8) {
		return "vs previous week";
	}
	
	// Check if it's approximately a month (28-31 days)
	if (daysDiff >= 28 && daysDiff <= 31) {
		return "vs previous month";
	}
	
	// Check if it's approximately a quarter (88-93 days, roughly 3 months)
	if (daysDiff >= 88 && daysDiff <= 93) {
		return "vs previous quarter";
	}
	
	// Check if it's approximately a year (365-366 days)
	if (daysDiff >= 365 && daysDiff <= 366) {
		return "vs previous year";
	}
	
	// For any other period, show the number of days
	return `vs previous ${daysDiff} days`;
};

/**
 * Format series name for display (cpu -> CPU, memory -> Memory, storage -> Storage)
 */
export const formatSeriesName = (series) => {
	if (!series) return '';
	const lowerSeries = series.toLowerCase();
	if (lowerSeries === 'cpu') return 'CPU';
	// Capitalize first letter for other series
	return series.charAt(0).toUpperCase() + series.slice(1);
};